<!-- For 'www' subdomain -->
<div *ngIf="subdomain == 'www'" style="border: 0px solid fuchsia;">
    <div class="rolling-zoom" style="border: 0px solid purple;">
        <!-- Slideshow markup: slides in a horizontal row, nav arrows and dots (dots populated by TS) -->
        <div #slideshowContainer class="slideshow" aria-roledescription="carousel" tabindex="0" (keydown)="onSlideshowKey($event)">
            <div class="slides">
                <img src="assets/images/LutzAngeles_HomePage_Cityscape_UnderConstruction_v5_{{ appService.themeService.currentThemeName }}.png" alt="Lutz Angeles Cityscape" draggable="false" />
                <img src="assets/images/LutzAngeles_HomePage_Cityscape_UnderConstruction_v4_{{ appService.themeService.currentThemeName }}.png" alt="Lutz Angeles Cityscape" draggable="false" />
                <img src="assets/images/LutzAngeles_HomePage_Cityscape_UnderConstruction_v3_{{ appService.themeService.currentThemeName }}.png" alt="Lutz Angeles Cityscape" draggable="false" />
            </div>
            <div class="slideshow-nav" aria-hidden="false">
                <button class="prev" aria-label="Previous slide" (click)="prevSlide()">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
                        <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
                <button class="next" aria-label="Next slide" (click)="nextSlide()">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
                        <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div class="slideshow-dots" role="tablist" aria-label="Slide navigation"></div>
        </div>
    </div>
    <br />
    <div class="info-box">
        <!-- (click)="onCardClick()" role="button" tabindex="0" (keydown.enter)="onCardClick()" (keydown.space)="onCardClick(); $event.preventDefault()"> -->
        <div class="title">WELCOME</div>
        <div class="subtitle">To the home of Mendl's</div>
        <div class="body">
            Lutz Angeles is the home of Mendl's Boulangerie-Pâtisserie, makers of
            amazingly delicious breads and pastries. We don't care if you live in Lutz Angeles
            or not! You are invited to signup and become a Lutz Angelino where you'll be looped
            in to stories and gossip happening in this crazy city.  If you do live here, please signup
            it's the best way to get bread and pastries from Mendl's.
        </div>
        <br *ngIf="!appService.isLoggedIn" />
        <!--
        <button *ngIf="!appService.isLoggedIn" mat-button (click)="appService.navigateTo('venuesettings', '')" class="standout-mat-button">
            <img src="https://lutzangeles.blob.core.windows.net/app/LutzAngelino_v4_{{ appService.themeService.currentThemeName }}.png" class="button-img-small" alt="icon" />
            LUTZ ANGELINOS - SIGNIN HERE
        </button>
        -->
        <br />
        <button mat-button (click)="appService.showSubscribeDialog()" class="standout-mat-button">
            <img src="https://lutzangeles.blob.core.windows.net/app/LutzAngelino_v4_{{ appService.themeService.currentThemeName }}.png" class="button-img-small" alt="icon" />
            SUBSCRIBE
        </button>
        <button mat-button (click)="shareLutzAngeles()" aria-label="Share this site" class="share-button" style="height: 48px;">
            <mat-icon>share</mat-icon>
            SHARE
        </button>
    </div>
    <br />
    <a mat-icon-button
       href="https://www.instagram.com/lutzangeles"
       target="_blank"
       rel="noopener noreferrer"
       aria-label="Visit Lutz Angeles on Instagram"
       class="instagram-button">
        <mat-icon svgIcon="instagram"></mat-icon>
    </a>
</div>

<!-- For 'mendls' subdomain -->
<div *ngIf="subdomain == 'mendls'">
    <div class="rolling-zoom" style="border: 0px solid purple;">
        <img src="https://lutzangeles.blob.core.windows.net/app/Mendls_Interior_v2_{{ appService.themeService.currentThemeName }}.png" />
    </div>
    <br />
    <div class="info-box">
        <div class="title">VOTRE BOULANGER</div>
        <div class="subtitle">Your local bakery</div>
        <div class="body">
            Mendl's is looking for fans, not customers.  It's our goal to make incredible bread and
            pastries because we love watching people's amazement as they bite into a canele for the first
            time, or battle over a baguette for the last bite.  Make sure to signup and become a verified
            Lutz Angelino where you can opt-in to get notifications of when we are baking in your area.
        </div>
        <br *ngIf="!appService.isLoggedIn" />
        <!--
    <button *ngIf="!appService.isLoggedIn" mat-button (click)="appService.navigateTo('venuesettings', '')" class="standout-mat-button">
        <img src="https://lutzangeles.blob.core.windows.net/app/LutzAngelino_v4_{{ appService.themeService.currentThemeName }}.png" class="button-img-small" alt="icon" />
        LUTZ ANGELINOS - SIGNIN HERE
    </button>
    -->
        <br />
        <button mat-button (click)="appService.showSubscribeDialog()" class="standout-mat-button">
            <img src="https://lutzangeles.blob.core.windows.net/app/LutzAngelino_v4_{{ appService.themeService.currentThemeName }}.png" class="button-img-small" alt="icon" />
            SUBSCRIBE
        </button>
        <button mat-button (click)="shareMendls()" aria-label="Share this site" class="share-button" style="height: 48px;">
            <mat-icon>share</mat-icon>
            SHARE
        </button>
    </div>
</div>
<div *ngIf="subdomain == 'illustra'">
    <div class="rolling-zoom" style="border: 0px solid purple;">
        <img src="https://lutzangeles.blob.core.windows.net/app/Illustra_Exterior_zoomable_rolling.png" />
    </div>
    <br />
    <div class="card-center-wrapper">
        <mat-card class="clickable-card" role="button" tabindex="0">
            <mat-card-header class="login-header">
                <mat-card-title>
                    <span>ILLUSTRA</span>
                </mat-card-title>
                <mat-card-subtitle>Where Lutz Angelinos come to flourish</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                The three cardinal, trapezoidal formations, hereto made orientable in our diagram by connecting the various points, HIGK, PEGQ and LMNO, creating our geometric configurations, which have no properties, but with location...
                <br />
                <br />
                <a href="#" (click)="appService.goToSubdomain('www')">Back to Lutz Angeles™</a>
            </mat-card-content>
        </mat-card>
    </div>
    <br />
    <a mat-icon-button
       href="https://www.instagram.com/lutzangeles"
       target="_blank"
       rel="noopener noreferrer"
       aria-label="Visit Lutz Angeles on Instagram"
       class="instagram-button">
        <mat-icon svgIcon="instagram"></mat-icon>
    </a>
</div>


